<template>
  <div class="page manage-page px-5">
    <upload-nav name="manage" />

    <content-top-header class="content-top-header-tab">
      <template slot="topHeader">
        <ul>
          <li
            v-for="filter in tabFilterOptions"
            :key="filter.id"
            :href="`#${filter.value}`"
            :class="{ 'active tab-active': isActiveFilter(filter.value) }"
          >
            <label @click="setActiveInnerFilter(filter.value)" class="innerBold">{{ filter.title }}</label>
          </li>
        </ul>
      </template>
    </content-top-header>

    <content-top-header 
      v-if="activeInnerFilter != 'videos'"
     class="manage-tab-content content-top-header-tab"
    >
      <template slot="topHeader">
        <ul>
          <li
            v-for="tab in getInnerMenuTabs(activeInnerFilter)"
            :key="tab.id"
            :href="`#${tab.id}`"
            :class="{ active: isActiveInnerTab(tab.id) }"
          >
            <label @click="setInnerTab(tab.id)">{{ tab.title }}</label>
          </li>
        </ul>
      </template>
    </content-top-header>

    <div 
      v-show="active_tab === 'content'" 
      :class="activeInnerFilter != 'videos' ? 'mt-180' : 'mt-130'"
    >
      <!-- <manage-product
        v-show="activeInnerFilter === 'products'"
        ref="manageProduct"
      /> -->
      <manage-album
        v-show="activeInnerFilter === 'albums'"
        ref="manageAlbum"
        :textBtnToRight="
          activeInnerFilter == 'albums' &&
          (activeInnerTab == 'published' || activeInnerTab == 'privated')
        "
      />
      <!-- <manage-video v-show="activeInnerFilter === 'videos'" ref="manageVideo" /> -->
    </div>
  </div>
</template>

<script type="text/javascript" src="./index.ctrl.js"></script>
<style scoped src="../../../static/styles/manage.scss" lang="scss"></style>
<style lang="scss" scoped>
.tabSelectMenu {
  /deep/.input-group--select .input-group__selections__comma {
    font-weight: 400;
  }
}
</style>

<script>
// import { mapGetters } from 'vuex'
import activityItem from '@/components/activityitem'
import contentTopHeader from '@/components/contentTopHeader'
// import manageProduct from '@/views/product/components/manageProduct'
import manageAlbum from '@/views/album/components/manageAlbum'
// import manageVideo from '@/views/video/components/manageVideo'
import payments from '@/views/payments'
import settings from '@/views/settings'
import uploadNav from '../upload/components/nav'

export default {
  components: {
    activityItem,
    contentTopHeader,
    // manageProduct,
    manageAlbum,
    // manageVideo,
    payments,
    settings,
    uploadNav,
  },

  data() {
    return {
      replaceTopMenu: [
        { id: 'manage', title: 'Manage', pathName: 'ManageIndex', icon: require('../../../static/images/file-copies.svg') },
      ],
      active_tab: 'content',
      activeInnerFilter: 'albums',
      activeInnerTab: 'published',
      tabFilterOptions: [
        {
          title: 'Albums', value: 'albums',
        },
        // {
        //   title: 'Videos', value: 'videos',
        // },
        // {
        //   title: 'Products', value: 'products',
        // },
      ],
      page_index: 1,
      total_pages: 1,
      items_per_page: 8 * 1,
      activities: [],
      isPageReady: false,
    }
  },

  computed: {
    userType() {
      return this.$store.getters['auth/userType']
    },
    videosMenuTabs() {
      const tabs = []
      return tabs
    },
    productMenuTabs() {
      const tabs = [
        { id: 'published', title: 'Inventory' },
        { id: 'privated', title: 'Private' },
        { id: 'collaborated', title: 'Collaborations' },
        // { id: 'pending', title: 'Pending collaborations' },
      ]
      return tabs
    },
    albumsMenuTabs() {
      const tabs = [
        { id: 'published', title: 'Published' },
        { id: 'privated', title: 'Private' },
        // { id: 'exclusives', title: 'Video Exclusives' },
        // { id: 'video_only', title: 'Video Attachments' },
        { id: 'collaborated', title: 'Collaborations' },
        // { id: 'pending', title: 'Pending Collaborations' },
      ]
      return tabs
    },
    currentUser() {
      return this.$store.state.auth.user
    },
  },
  methods: {
    setActiveInnerFilter(filter) {
      this.activeInnerFilter = filter
    },
    isActiveFilter(filter) {
      return this.activeInnerFilter === filter
    },
    setInnerTab(id) {
      this.activeInnerTab = id

      switch (this.activeInnerFilter) {
        case 'products':
          // this.$refs.manageProduct.setProductFilter(id)
          break

        case 'albums':
          this.$refs.manageAlbum.setAlbumFilter(id)
          break

        // case 'videos':
        //   this.$refs.manageVideo.setVideoFilter(id)
        //   break

        default:
          return
      }
    },
    getInnerMenuTabs(filter) {
      switch (filter) {
        case 'products':
          return this.productMenuTabs
        case 'albums':
          return this.albumsMenuTabs
        // case 'videos':
        //   return this.videosMenuTabs
        default:
          []
      }
    },
    isActiveTab(tab) {
      return this.active_tab == tab
    },
    isActiveInnerTab(tab) {
      return this.activeInnerTab == tab
    },
  },
  watch: {
    activeInnerFilter(val) {
      const getInnerTab = this.getInnerMenuTabs(val).find(tab => tab.id == this.activeInnerTab)
      // if (val === 'videos') return

      const fallback = this.getInnerMenuTabs(val)[0].id || ''
      if (!getInnerTab) {
        this.activeInnerTab = fallback
      } else {
        this.activeInnerTab = getInnerTab.id
      }

      this.setInnerTab(this.activeInnerTab)
    },
  },
  created() {
    if (this.userType === 'listener') {
      this.active_tab = 'payment'
    }
    if (localStorage.getItem("release_product")) {
      this.activeInnerFilter = 'products'
    } // else if (localStorage.getItem("release_video")) {
    //   this.activeInnerFilter = 'videos'
    // }
  },
  mounted() {
    const {activeInnerFilter, activeInnerTab} = this.$route.params
    if (this.$route.query['tab']) {
      this.activeInnerFilter = this.$route.query['tab']
    }
    if (activeInnerFilter) {
      this.activeInnerFilter = activeInnerFilter
    }

    if (activeInnerTab) {
      this.activeInnerTab = activeInnerTab
    } else {
      this.activeInnerTab = 'published'
    }

    this.setInnerTab(this.activeInnerTab)
  },
}
</script>



// WEBPACK FOOTER //
// index.vue?dc397a3e